import React from 'react';
import * as ReactDOM from 'react-dom';

import { GastoDiario } from '../../Gastos/tipos';
import { imprimirMetodoDePago, imprimirMotivo, imprimirMotivoGastoDiario } from '../../utilidades';
import { ListaDeResponsables, PagosAsociadosAlAreaDelDia, PagosEventualesDelDia } from '../tipos';

function escribirMonto(monto: number) {
    const valorConPuntos = monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + valorConPuntos;
}

interface Props {
    fecha: string;

    totalPagosCuotasYCobrosCalculadosDelDia: number;
    totalOtrosPagos: number;
    totalPagos: number;

    totalPagosDelDiaPreu: number;
    totalPagosDelDiaIngles: number;

    pagosDelDia: ReadonlyArray<PagosAsociadosAlAreaDelDia>;

    gastos: ReadonlyArray<GastoDiario>;
    totalGastosDiarios: number;
    listaDeResponsables: ReadonlyArray<ListaDeResponsables>;

    pagosEventualesDelDia: ReadonlyArray<PagosEventualesDelDia>;

    totalEfectivo: number;
    totalTarjetaDebito: number;
    totalTarjetaCredito: number;
    totalDeposito: number;
    totalTransferencia: number;
    totalCheque: number;

    totalEfectivoMenosGastosDiarios: number;

    alCerrar(): void;
}

// TODO Buscar la forma de cargar el logo
const InformeImprimible: React.FunctionComponent<Props> = props => {
    const {
        alCerrar,
        fecha,

        totalPagosCuotasYCobrosCalculadosDelDia,
        totalOtrosPagos,
        totalPagos,

        totalPagosDelDiaPreu,
        totalPagosDelDiaIngles,

        gastos,
        totalGastosDiarios,
        listaDeResponsables,

        pagosEventualesDelDia,

        totalEfectivo,
        totalTarjetaDebito,
        totalTarjetaCredito,
        totalDeposito,
        totalTransferencia,
        totalCheque,

        totalEfectivoMenosGastosDiarios,
    } = props;

    function retornarNombreResponsable(id: string) {
        return listaDeResponsables.filter(x => x.id === id).map(x => x.nombre);
    }

    return (
        <WindowPortal alCerrar={alCerrar}>
            <style>{`
                @page {
                    size: Letter;
                }
                @media print {
                    aside {
                        display: none;
                    }
                    flex-ingreso-formas-de-pago {
                        display: block;
                    }
                    flex-container-column {
                        display: block;
                    }
                    table.flex {
                        page-break-before: always;
                    }
                    body {
                        display: block;
                    }
                }
                body {
                    font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
                    font-size: 12px;
                    margin-top: 1cm;
                }
                caption {
                    text-align: left;
                    font-weight: bold;
                }
                .fecha {
                    text-align: center;
                }
                .nombre-alumno {
                    margin-top: 1cm;
                    font-size: 14px;
                    font-weight: bold;
                }
                table {
                    border-collapse: collapse;
                    margin-top: 10px;
                    width: 100%;
                }
                table, th, td {
                    border: 1px solid black;
                    height: 6mm;
                    padding: 5px;
                }
                th.titulo {
                    border: 0px;
                    height: 6mm;
                    padding: 0;
                }
                th.title {
                    text-align: center;
                    padding: 5px;
                    font-weight: bold;
                    font-size: 12px;
                }
                th.value {
                    text-align: left;
                    margin-left:15%;
                    margin-right:15%;
                    padding: 5px;
                    font-weight: normal;
                    font-size: 12px;
                }
                td.total {
                    text-align: left;
                    margin-left:15%;
                    margin-right:15%;
                    padding: 5px;
                    font-weight: bold;
                    font-size: 12px;
                }
                td {
                    text-align: left;
                    margin-left:15%;
                    margin-right:15%;
                    padding: 5px;
                    font-weight: bold;
                    font-size: 12px;
                }
                .flex-titulo {
                    display: flex;
                    position: absolute;
                    top:0;
                    left: 0;
                    right: 0;
                    text-align: center;
                    width: 100%;
                    flex-direction: column;

                }
                .flex-fecha {
                    display: flex;
                    text-align: center;
                    flex-direction: column;
                }
                .flex-container {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-around;
                }
                .flex-ingreso-formas-de-pago {
                    display: flex;
                    width: 100%;
                    flex-direction: row;
                }
                .flex-container-column {
                    display: flex;
                    width: 100%;
                    flex-direction: column;
                }
                .flex-container-column-left {
                    display: flex;
                    width: 100%;
                    margin-right:2%;
                    flex-direction: column;
                }
                .flex-container-column-right {
                    display: flex;
                    width: 100%;
                    margin-right:1.6%;
                    flex-direction: column;
                }
                .tabla-efectivo-menos-gastos {
                    width: 49.8%;
                }
                .td-efectivo {
                    width: 64.3%;
                }
            `}</style>
            <header>
                <div className='flex-container-column'>
                    <div className='flex-titulo'>
                        <div>
                            <h1>Informe financiaro diario</h1>
                        </div>
                        <div className='flex-fecha'>{fecha}</div>
                    </div>
                </div>
            </header>
            <body>
                <div className='flex-container'>
                    <div className='flex-container-column-left'>
                        <table className='flex'>
                            <caption>Total pagos del día</caption>
                            <thead>
                                <tr>
                                    <th className='title'>Tipo</th>
                                    <th className='title'>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Cuotas, gastos notariales y abonos iniciales</td>
                                    <td>
                                        {escribirMonto(totalPagosCuotasYCobrosCalculadosDelDia)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Otros pagos</td>
                                    <td>{escribirMonto(totalOtrosPagos)}</td>
                                </tr>
                                <tr>
                                    <td className='total'>Total</td>
                                    <td className='total'>{escribirMonto(totalPagos)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='flex-container-column-right'>
                        <table className='flex'>
                            <caption>Total pagos por área</caption>
                            <thead>
                                <tr>
                                    <th className='title'>Área</th>
                                    <th className='title'>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='value'>Preuniversitario</td>
                                    <td className='value'>{escribirMonto(totalPagosDelDiaPreu)}</td>
                                </tr>
                                <tr>
                                    <td className='value'>Inglés</td>
                                    <td className='value'>
                                        {escribirMonto(totalPagosDelDiaIngles)}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='total'>Total</td>
                                    <td className='total'>
                                        {escribirMonto(totalPagosCuotasYCobrosCalculadosDelDia)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <table>
                    <caption>Gastos diarios</caption>
                    <thead>
                        <tr>
                            <th className='title'>Reponsable</th>
                            <th className='title'>Motivo</th>
                            <th className='title'>Observacion</th>
                            <th className='title'>Monto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gastos.map((gasto, indice) => (
                            <tr key={indice}>
                                <td>{retornarNombreResponsable(gasto.responsableGasto)}</td>
                                <td>
                                    {gasto.motivoGasto === 'otro'
                                        ? gasto.otroMotivoGasto!
                                        : imprimirMotivoGastoDiario(gasto.motivoGasto)}
                                </td>
                                <td>{gasto.observacionesGasto}</td>
                                <td>{escribirMonto(gasto.montoGasto)}</td>
                            </tr>
                        ))}
                        <tr>
                            <td />
                            <td />
                            <td>Total</td>
                            <td>{escribirMonto(totalGastosDiarios)}</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <caption>Otros pagos</caption>
                    <thead>
                        <tr>
                            <th className='title'>Motivo</th>
                            <th className='title'>Forma de pago</th>
                            <th className='title'>Monto</th>
                            <th className='title'>Intereses</th>
                            <th className='title'>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pagosEventualesDelDia.map(pago => (
                            <tr>
                                <td>
                                    {pago.motivo === 'otro'
                                        ? pago.otroMotivo!
                                        : imprimirMotivo(pago.motivo)}
                                </td>
                                <td>
                                    {pago.metodoDePago._tipo === 'tarjeta'
                                        ? pago.metodoDePago._tipoDeTarjeta === 'debito'
                                            ? 'Débito'
                                            : 'Crédito'
                                        : imprimirMetodoDePago(pago.formaDePago)}
                                </td>
                                <td>{escribirMonto(pago.monto)}</td>
                                <td>{escribirMonto(pago.intereses)}</td>
                                <td>{escribirMonto(pago.montoTotal)}</td>
                            </tr>
                        ))}
                        <tr>
                            <td />
                            <td />
                            <td />
                            <td>Total</td>
                            <td>{escribirMonto(totalOtrosPagos)}</td>
                        </tr>
                    </tbody>
                </table>
                <div className='flex-ingreso-formas-de-pago'>
                    <div className='flex-container-column-left'>
                        <table className='flex'>
                            <caption>Ingreso total de cada forma de pago</caption>
                            <thead>
                                <tr>
                                    <th className='title'>Forma de pago</th>
                                    <th className='title'>Monto</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Efectivo</td>
                                    <td>{escribirMonto(totalEfectivo)}</td>
                                </tr>
                                <tr>
                                    <td>Tarjeta de débito</td>
                                    <td>{escribirMonto(totalTarjetaDebito)}</td>
                                </tr>
                                <tr>
                                    <td>Tarjeta de crédito</td>
                                    <td>{escribirMonto(totalTarjetaCredito)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='flex-container-column-right'>
                        <table className='flex'>
                            <caption>
                                <br />
                            </caption>
                            <thead>
                                <tr>
                                    <th className='title'>Forma de pago</th>
                                    <th className='title'>Monto</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Depósito</td>
                                    <td>{escribirMonto(totalDeposito)}</td>
                                </tr>
                                <tr>
                                    <td>Transferencia</td>
                                    <td>{escribirMonto(totalTransferencia)}</td>
                                </tr>
                                <tr>
                                    <td>Cheque</td>
                                    <td>{escribirMonto(totalCheque)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <table className='tabla-efectivo-menos-gastos'>
                    <thead />
                    <tbody>
                        <tr>
                            <td className='td-Efectivo'>Efectivo total del día</td>
                            <td>{escribirMonto(totalEfectivoMenosGastosDiarios)}</td>
                        </tr>
                    </tbody>
                </table>
            </body>
        </WindowPortal>
    );
};

class WindowPortal extends React.PureComponent<{ alCerrar(): void }> {
    private readonly element = document.createElement('div');
    private externalWindow: Window | null = null;

    public componentWillMount() {
        this.externalWindow = window.open();
        this.externalWindow!.document.body.appendChild(this.element);
        this.externalWindow!.addEventListener('beforeunload', () => {
            this.props.alCerrar();
        });
    }

    public componentWillUnmount() {
        this.externalWindow!.close();
    }

    public render() {
        return ReactDOM.createPortal(this.props.children, this.element);
    }
}

export default InformeImprimible;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/Componentes/informeImprimible.tsx